var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRedshiftIcon = function SvgRedshiftIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.9 14.1l7.6 3.7V82l-7.6 3.7-12-35.7 12-35.9z",
    fill: "#5294CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1 14.1l-7.6 3.7V82l7.6 3.7 19-35.7-19-35.9zM50 76.5l37.9 9.2V14.1L50 23.3v53.2z",
    fill: "#205B99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 76.5l-37.9 9.2V14.1L50 23.3v53.2z",
    fill: "#5294CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1 100l14.5-7.2V7.2L59.1 0 44.7 47.6 59.1 100z",
    fill: "#5294CF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9 100l-14.5-7.2V7.2L40.9 0l12.9 50-12.9 50z",
    fill: "#205B99"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1 0H40.9v100h18.2V0z",
    fill: "#2E73B8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRedshiftIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/redshift-icon.f3749f28ad04e63a063a131ccb6318ee.svg";